import type {
  UpdateShopOriginAddressPayload,
  UpdateShopOriginAddressResponse,
} from '@fourthwall/services/dist/ShopsApiClient'
import { ShopsApiClient } from '@fourthwall/services/dist/ShopsApiClient'
import type { ApiError } from '@fourthwall/services/dist/types'
import { useMutation } from '@tanstack/react-query'

import { useCurrentShopQuery } from '../../../../../hooks/useCurrentShopQuery'

export const useUpdateShopOriginLocationMutation = (shopId: string) => {
  const { setCurrentShopData } = useCurrentShopQuery(undefined, { enabled: false })

  const updateShopOriginLocationMutation = useMutation<
    UpdateShopOriginAddressResponse,
    ApiError,
    UpdateShopOriginAddressPayload
  >({
    mutationFn: async (payload) => {
      const { data } = await ShopsApiClient.updateOriginAddress(shopId, payload)

      return data
    },
    onSuccess: (data) => {
      setCurrentShopData(data)
    },
  })

  return {
    updateShopOriginLocationMutation,
  }
}
